import { render } from "./McFaq.vue?vue&type=template&id=5d4abfda&scoped=true"
import script from "./McFaq.vue?vue&type=script&lang=js"
export * from "./McFaq.vue?vue&type=script&lang=js"

import "./McFaq.vue?vue&type=style&index=0&id=5d4abfda&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4abfda"]])

export default __exports__